import {Project} from 'airship/clients/wallet/types'

export enum Urgency {
  Low = 'low',
  Medium = 'medium',
  Highest = 'highest',
  Urgent = 'urgent',
}

export interface Context {
  project?: Project
}
